import AScene from '../../library/ExtendedObjects/AScene.js';
import gameData from '../../gameData.js';
import NavBar from './NavBar.js';
import Vials from './Vials.js';
import DragBug from '../DragBug.js';
import NumPad from './NumPad.js';
import Popup from './Popup.js';

export default class Game extends AScene {
  static get KEY() { return 'Game'; }

  create() {
    // console.log("GAME!");
    gameData.currentScene = 'Game';
    gameData.gameOver = false;
    gameData.gamePaused = false;
    gameData.roundOver = false;
    gameData.totalBugs = 0;
    gameData.totalBugCount = 0;
    gameData.level = 0;
    gameData.score = 0;
    gameData.graphingQuestions =
        [
          { question: 'How many Fuzz Bugs do you see?', answer: '' },
          { question: 'How many ~ Fuzz Bugs are there?', answer: '' },
          { question: 'What is the combined number of ~ and - Fuzz Bugs?', answer: '' },
          { question: 'How many more ~ Fuzz Bugs than - Fuzz Bugs?', answer: '' },
          { question: 'How many fewer ~ Fuzz Bugs than - Fuzz Bugs?', answer: '' }
        ];

    // console.log(gameData.fuzzColor, gameData.fuzzColor_Name, gameData.fuzzStencil, gameData.fuzzStencil_Color, gameData.fuzzStencil_Name);

    // clear out numpad property so that it is null; fixes problems when replaying game 2nd time through and opening the pause menu
    this.numPad = null;
    this.createGame();
  }

  createGame() {
    this.initializePattern();
    this.createAssets();
    this.initializeQuestions();
  }

  initializePattern() {
    // set 5 random colors
    this.selectedColors = [...gameData.fuzzColors];
    this.shuffleArray(this.selectedColors);

    for (let i = 0; i < 5; i++) {
      this.selectedColors.pop();
    }

    // set number of bugs for each vial
    this.vialAmounts = [2, 3, 4];
    const rand = Phaser.Math.Between(1, 2);
    this.vialAmounts.push(rand === 1 ? 5 : 6);
    this.vialAmounts.push(rand === 1 ? Phaser.Math.Between(6, 7) : 7);
    this.shuffleArray(this.vialAmounts);

    // calculate total number of bugs needed
    this.allColors = [];
    for (let i = 0; i < this.vialAmounts.length; i++) {
      gameData.totalBugs += this.vialAmounts[i];

      // create an array with all necessary colors for drag bugs
      for (let s = 0; s < this.vialAmounts[i]; s++) {
        const obj = { color: this.selectedColors[i], ind: i };
        this.allColors.push(obj);
      }
    }
  }

  createAssets() {
    // console.log(gameData.fuzzColor, gameData.fuzzStencil_Color, gameData.fuzzStencil, gameData.customReplacementID)
    this.bg = this.addImage(this.mid.x, this.mid.y, 'Bckg');

    // this.floor = this.addImage(this.mid.x, this.mid.y*2, "Floor");

    if (this.shelf) this.shelf.destroy();
    this.shelf = this.addImage(-300, this.mid.y + 182, 'Platform');

    if (this.navBar) this.navBar.destroy();
    this.navBar = new NavBar(this);
    this.addToParent(this.navBar);
    this.navBar.setDepth(24);

    if (gameData.level === 0) {
      this.playSound('platform_tween');
      this.addTween(this.shelf, 1000, { x: this.mid.x }, Phaser.Math.Easing.Quadratic.Out);
    }
    else {
      this.shelf.x = this.mid.x;
    }

    this.vials = new Vials(this, this.selectedColors, this.vialAmounts);

    this.dragBugs = [];
    for (let a = 0; a < gameData.totalBugs; a++) {
      const randX = Phaser.Math.Between(75, this.mid.x * 2 - 75);
      const fb = new DragBug(this, randX, this.mid.y * 2 - 30, .3, 'Idle', a, this.allColors[a].ind);

      this.dragBugs.push(fb);

      fb.color = fb.startColor = this.allColors[a].color.color;
      fb.colorName = fb.startColorName = this.allColors[a].color.name;
    }

    let customVial;
    this.vials.vials.forEach((vial) => {
      if (vial.isCustom) customVial = vial;
    });


    this.dragBugs.forEach((bug) => {
      // console.log(bug.startColor, customVial.startColor);

      if (gameData.customFuzzbug) {
        // console.log(bug.startColor, customVial.startColor);
        if (bug.startColor === customVial.startColor) {
          // console.log(bug.patternID, gameData.customReplacementID, customVial.ind);
          bug.patternID = customVial.ind;
          bug.isPattern = true;
          bug.startColorName = 'Custom';
          bug.customizeUser();
        }
        else {
          bug.paintFuzzbug();
        }
      }
      else {
        bug.paintFuzzbug();
      }

    });
  };

  initializeQuestions() {
    this.activeBugs = [];
    gameData.graphingQuestions[0].answer = gameData.totalBugs;
    this.activeBugs.push([0]);

    //----------------------------

    const randVial = this.vials.vials[Phaser.Math.Between(0, this.vials.vials.length - 1)];

    gameData.graphingQuestions[1].question = gameData.graphingQuestions[1].question.split('~').join(randVial.name);
    gameData.graphingQuestions[1].answer = randVial.amount;
    gameData.graphingQuestions[1].vials = [randVial];
    this.activeBugs.push([randVial]);

    //----------------------------

    for (let q = 2; q < 5; q++) {
      this.max = this.vials.getMax();
      this.min = this.vials.getMin(this.max.amount);

      if (q === 2) {
        gameData.graphingQuestions[q].question = gameData.graphingQuestions[q].question.split('~').join(this.max.name);
        gameData.graphingQuestions[q].question = gameData.graphingQuestions[q].question.split('-').join(this.min.name);
        gameData.graphingQuestions[q].answer = this.max.amount + this.min.amount;
        gameData.graphingQuestions[q].vials = [this.max, this.min];
      }
      else if (q === 3) {
        gameData.graphingQuestions[q].question = gameData.graphingQuestions[q].question.split('~').join(this.max.name);
        gameData.graphingQuestions[q].question = gameData.graphingQuestions[q].question.split('-').join(this.min.name);
        gameData.graphingQuestions[q].answer = this.max.amount - this.min.amount;
        gameData.graphingQuestions[q].vials = [this.max, this.min];
      }
      else if (q === 4) {
        gameData.graphingQuestions[q].question = gameData.graphingQuestions[q].question.split('~').join(this.min.name);
        gameData.graphingQuestions[q].question = gameData.graphingQuestions[q].question.split('-').join(this.max.name);
        gameData.graphingQuestions[q].answer = this.max.amount - this.min.amount;
        gameData.graphingQuestions[q].vials = [this.min, this.max];
      }

      this.activeBugs.push([this.min, this.max]);
    }

    // console.log(gameData.graphingQuestions);
  }

  pauseGame() {
    gameData.gamePaused = true;

    this.playSound('click');

    this.navBar.home.setEnabled(false);
    this.dragBugs.forEach((bug) => {bug.disabled();});
    if (this.numPad) this.numPad.disableKeys();

    this.popup = new Popup(this);
  }

  resumeGame() {
    gameData.gamePaused = false;

    this.navBar.home.setEnabled(true);
    this.dragBugs.forEach((bug) => {bug.enabled();});
    if (this.numPad) this.numPad.enableKeys();

    this.popup.destroy();
  }

  tweenOutGame() {
    // console.log("tweening out game");
    gameData.roundOver = true;
    this.navBar.tweenOutInstructions();

    this.vials.bunchVials();

    this.dragBugs.forEach((bugs) => {bugs.bunch();});

    this.numPad = new NumPad(this, this.mid.x * 2 + 225, this.mid.y);
    this.numPad.setDepth(30);
  };

  tweenOutEnd() {
    // console.log("tweening out TO CUSTOMIZER");
    gameData.roundOver = true;
    this.navBar.tweenOutNav();

    this.vials.tweenOutVials();

    this.dragBugs.forEach((bugs) => {bugs.tweenOut();});

    this.numPad.tweenOutNumPad();

    this.playSound('correct_pattern');

    this.addTween(
      this.shelf,
      1000,
      { x: -500 },
      Phaser.Math.Easing.Quadratic.In,
      () => {this.cleanUp('Customize');}
    );
  };

  createTrueEnding() {
    // console.log("GAME OVER!");
    this.navBar.tweenOutNav();
    this.vials.tweenOutVials();
    this.dragBugs.forEach((bugs) => {bugs.tweenOut();});
    this.numPad.tweenOutNumPad();
    this.addTween(this.shelf, 1000, { x: -550 }, Phaser.Math.Easing.Quadratic.In);

    this.title = this.addImage(this.mid.x, -200, 'Fuzztastic');

    // this.info = this.addImage(this.mid.x, this.mid.y + 50, "Play_Again_Text");
    this.restartBtn = this.addButton(this.mid.x, this.mid.y + 200, 'Btn_Play_Again', {}, () => {
      this.restartBtn.setEnabled(false);
      this.cleanUp('Intro');
    });

    // this.info.setAlpha(0);
    this.restartBtn.setScale(0);
    this.restartBtn.setEnabled(false);
    this.title.setDepth(10);

    // this.info.setDepth(10);
    this.restartBtn.setDepth(10);

    this.playSound('fuzztastic');

    this.addTween(
      this.title,
      1000,
      { y: this.title.width / 2 - 100 },
      Phaser.Math.Easing.Back.Out,
      () => {
        // this.addTween(this.info, 1000, {alpha:1}, Phaser.Math.Easing.Quadratic.Out);
        this.addTween(
          this.restartBtn,
          1000,
          { scaleX: 1, scaleY: 1 },
          Phaser.Math.Easing.Back.Out,
          () => {
            this.restartBtn.setEnabled(true);
          }
        );
      }
    );
  };

  cleanUp(scene) {
    // console.log(gameData.level);
    this.dragBugs.forEach((bug) => {
      bug.cleanUp();
      bug = null;
    });
    this.dragBugs = [];
    this.selectedColors = [];
    this.vialAmounts = [];
    this.activeBugs = [];
    this.questionsHigh = null;

    gameData.gameOver = false;
    gameData.roundOver = false;
    gameData.counter = 0;
    gameData.score = 0;
    gameData.totalBugs = 0;

    if (this.numPad) {
      this.numPad.cleanUp();
      this.numPad.destroy();
    }
    this.navBar.cleanUp();
    this.navBar.destroy();
    this.shelf.destroy();

    this.vials.cleanUp();
    this.vials.destroy();
    console.log(scene);
    if (scene) this.scene.start(scene);
  }
}